import React, { useContext, useEffect, useState } from 'react';
import { GlobalAppContext } from '../App';
import { ACTION_TYPE, TPEBasicModal } from './TPEBasicModal';
import StringUtils from 'src/utils/stringUtils';
import TPEErrorWatcher from './TPEErrorWatcher';

export default function MarkNotificationsComplete(props: {triggerAction: string, selectedNotifications: any[], postProcess?: () => any}) {
    const { triggerAction, selectedNotifications, postProcess = () => {}} = props;

    const { services } = useContext(GlobalAppContext);

    const [ markCompletePayload, setMarkCompletePayload ] = useState(null as unknown as any);
    const [ showMarkCompleteConfirmationModal, setShowMarkCompleteConfirmationModal ] = useState(false);

    const [markCompleteResult, markingComplete, markCompleteError] = services.dashboardService.markNotificationsComplete(markCompletePayload);

    const markComplete = () => {
        setShowMarkCompleteConfirmationModal(false);
        const markCompleteNotifications: any[] = [];
        selectedNotifications.forEach(x => markCompleteNotifications.push({
            owner: x.owner,
            notificationId: x.taskId
        }));
        
        setMarkCompletePayload({ notifications: markCompleteNotifications });
    }

    useEffect(() => {
        if (StringUtils.isNullOrEmpty(triggerAction) || selectedNotifications == null || selectedNotifications.length == 0) {
            return;
        }
        setShowMarkCompleteConfirmationModal(true);
    }, [triggerAction])

    useEffect(() => {
        if (markCompleteResult == null) {
            return;
        }
        services.messageService.showSuccessAutoDismissBanner(`${markCompleteResult.numSuccessful} task(s) have been marked as complete.`);
        if (markCompleteResult.numFailed > 0) {
            let failedMessage = '';
            failedMessage = failedMessage + `${markCompleteResult.numFailed} task(s) failed to be marked as complete. `
            markCompleteResult.errors.forEach((x: string) => failedMessage = failedMessage + `${x} `);
            services.messageService.showErrorBanner(failedMessage);
        }
        postProcess();
    }, [markCompleteResult])

    return <>
            <TPEBasicModal
                title="Mark as completed confirmation"
                action={ACTION_TYPE.CONFIRM_CANCEL}
                visible={showMarkCompleteConfirmationModal}
                onConfirm={markComplete}
                onCancel={() => setShowMarkCompleteConfirmationModal(false)}
            >
                This will mark the <b>{selectedNotifications.length}</b> selected task(s) as completed. Confirm to proceed.
            </TPEBasicModal>
            <TPEErrorWatcher services={services} errors={[markCompleteError]} />
        </>
}